import React from 'react';

export const MenuLayout = ({
    children,
    footer,
    banners,
}: {
    children: React.ReactNode;
    footer?: React.ReactNode;
    banners?: React.ReactNode;
}) => {
    return (
        <div className='flex min-h-full flex-1 flex-col gap-4 bg-neutral-20'>
            {banners && <div className={'grid grid-cols-2 gap-2 px-4'}>{banners}</div>}
            <div className={'flex flex-1 flex-col rounded-lg bg-neutral-10'}>
                <div className={'flex-1'}>{children}</div>
            </div>
            <div className='pt- mt-auto flex flex-col gap-4 pb-4 pt-2'>{footer}</div>
        </div>
    );
};
